import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { configureRpcUrls } from "@gardio/contracts/polygon";
import { configureEvmRpcUrls } from "@gardio/extensions";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { AppConfig } from "types/appConfig";
import { getAppConfig } from "utils/AxiosUtil";

// Server-owned constants. Keyed by network because the values are per-chain, and
// left at the client's default staleTime: Infinity — they only change on a deploy.
//
// The libs are configured inside queryFn rather than in an effect: a chain read
// can fire in the same commit that renders a component, and an effect would run
// after it. Configuring before the promise resolves means any consumer that can
// see the data can also see a configured lib.
export function useAppConfig() {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery<AppConfig>({
    queryKey: ["appConfig", networkType],
    queryFn: async () => {
      const res = await getAppConfig(networkType);
      const config: AppConfig = res.data;
      configureRpcUrls({ [networkType]: config.rpcUrl });
      configureEvmRpcUrls({ [networkType]: config.rpcUrl });
      return config;
    },
    enabled: !!user,
  });
}
